export default __webpack_public_path__ + "media/settings.ada6d9f4.svg";